import { React, useRef, useState, useEffect } from 'react'
import { Container, Row, Col, Form, Button, Modal, Badge } from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ReactLoading from "react-loading";
import Swal from 'sweetalert2'
import { AgentString } from '../../../constants/Agent-String'
import { PublicStrings } from '../../../constants/Public-Strings'
import { successToast, warningToast } from '../../../constants/Toasts-Components'
import ServicesRequest from "../../../service/ServiceRequest";

const Profile = (props) => {

    let serviceRequestObj = new ServicesRequest("user");

    const { config } = useSelector((state) => state.auth)

    const [inputs, setInputs] = useState({
        name : '',
        email : '',
        surname : '',
        agency : null,
        is_agent: false,
        is_agency_boss: false,
        is_agency_admin: false,
        is_business_manager: false,
        is_internal_backoffice_manager: false,
        is_internal_backoffice_operator: false,
        is_institute_backoffice_manager: false,
        is_institute_backoffice_operator: false,
        managed_agencies: [],
        password: '',
        confirm_password : '',
        can_force_edit: false,
        min_commission: 0,
        max_commission: 0

    });

    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState([]);
    const [confirmPassword, setConfirmPassword] = useState([]);
    const [showPasswordModal,setShowPasswordModal] = useState(false);

    useEffect(() => {
        if (config) {
            setInputs({
                name: config.first_name || config.name || '',
                surname: config.last_name || config.surname || '',
                email: config.email || '',
                agency: config.agency?.name || '',
                is_agent: config.is_agent,
                is_agency_boss: config.is_agency_boss,
                is_agency_admin: config.is_agency_admin,
                is_business_manager: config.is_business_manager,
                is_internal_backoffice_manager: config.is_internal_backoffice_manager,
                is_internal_backoffice_operator: config.is_internal_backoffice_operator,
                is_institute_backoffice_manager: config.is_institute_backoffice_manager,
                is_institute_backoffice_operator: config.is_institute_backoffice_operator,
                managed_agencies: config.managed_agencies || [], 
                password: '',
                confirm_password: '',
                can_force_edit: config.can_force_edit,
                min_commission: config.min_commission,
                max_commission: config.max_commission
            });
        }
    }, [config])

    function handleClose(){
        setShowPasswordModal(false)
    }

    async function passwordChangeSubmit(e){
        e.preventDefault()
        if(password.length < 8){
            warningToast("Password must be 8 or more")
        }else if(password !== confirmPassword){
            warningToast("Password not matched")
        }else{

            const response = await serviceRequestObj.changePasswordUserOrAgent({password:password,confirm_password:confirmPassword},inputs.email)
            console.log(response)
            if(!response.response){
                successToast("Password Changed")
                setPassword("");
                setConfirmPassword("");
                setShowPasswordModal(false);
                
            }else{
                warningToast(response.response.data.message)
            }
        }
   } 

    // Helper function to get current role
    const getCurrentRole = () => {
        if (inputs.is_agent) return 'is_agent';
        if (inputs.is_agency_boss) return 'is_agency_boss';
        if (inputs.is_agency_admin) return 'is_agency_admin';
        if (inputs.is_business_manager) return 'is_business_manager';
        if (inputs.is_internal_backoffice_manager) return 'is_internal_backoffice_manager';
        if (inputs.is_internal_backoffice_operator) return 'is_internal_backoffice_operator';
        if (inputs.is_institute_backoffice_manager) return 'is_institute_backoffice_manager';
        if (inputs.is_institute_backoffice_operator) return 'is_institute_backoffice_operator';
        return 'none';
    }

    // Get available role options based on current user's permissions
    const getAvailableRoleOptions = () => {
         return [
                { value: 'none', label: 'Seleziona Ruolo' },
                { value: 'is_agent', label: 'Agente di Agenzia' },
                { value: 'is_agency_boss', label: 'Responsabile di Agenzia' },
                { value: 'is_agency_admin', label: 'Amministratore di Agenzia' },
                { value: 'is_business_manager', label: 'Responsabile Commerciale' },
                { value: 'is_internal_backoffice_manager', label: 'Responsabile Backoffice Interno' },
                { value: 'is_internal_backoffice_operator', label: 'Operatore Backoffice Interno' },
                { value: 'is_institute_backoffice_manager', label: 'Responsabile Backoffice Istituto' },
                { value: 'is_institute_backoffice_operator', label: 'Operatore Backoffice Istituto' }
            ];
    }

    return (
        <>
            <Container fluid>
            <Modal show={showPasswordModal} onHide={handleClose}>
                <Modal.Header closeButton>
                            <Modal.Title as="h5">Cambiare la password</Modal.Title>
                </Modal.Header>
                <Form className='g-3' onSubmit={passwordChangeSubmit}>
                <Modal.Body>

                    
                <div className=" mb-3" >
                                            <Form.Label htmlFor='password' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.password}</Form.Label>
                                            <Form.Control type='password' className="form-control" name='password' placeholder=''
                                                maxLength="30"
                                                value={password}
                                                onChange={(e)=>setPassword(e.target.value)}
                                                required
                                            />
                </div>
                <div className=" mb-3" >
                                            <Form.Label htmlFor='confirm_password' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.confirmPassword}</Form.Label>
                                            <Form.Control type='password' className="form-control" name='confirm_password' placeholder=''
                                                maxLength="30"
                                                value={confirmPassword}
                                                onChange={(e)=>setConfirmPassword(e.target.value)}
                                                required
                                            />
                </div>
                
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cancellare</Button>
                    <Button variant="primary" type="submit" >Salva Modifiche</ Button>
                </Modal.Footer>
                </Form>
            </Modal>
                <Row>
                    <Col lg="12">
                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                            <div className="d-flex align-items-center justify-content-between">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb p-0 mb-0">
                                        <li className="breadcrumb-item active" aria-current="page">Profilo</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </Col>
                    <Col lg="12" className="mb-3 d-flex justify-content-between">
                        <h4 className="font-weight-bold d-flex align-items-center">Profilo</h4>
                    </Col>
                    <Col lg="12">
                        <Card>
                            <Card.Body>
                                {loading ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                                        <ReactLoading
                                            type={"spin"}
                                            color={"#007bff"}
                                            height={50}
                                            width={50}
                                        />
                                    </div>
                                ) : (
                                <Form className=" g-3">
                                    <div className='row'>

                                        <div className="col-md-6 mb-3" key="1">
                                            <Form.Label htmlFor='name' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.name}</Form.Label>
                                            <Form.Control type='text' className="form-control" name='name' placeholder=''
                                                value={inputs["name"]}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3" key="2">
                                            <Form.Label htmlFor='surname' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.surname}</Form.Label>
                                            <Form.Control type='surname' className="form-control" name='surname' placeholder=''
                                                value={inputs["surname"]}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3" key="3">
                                            <Form.Label htmlFor='email' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.email}</Form.Label>
                                            <Form.Control type='email' className="form-control" name='email' placeholder=''
                                                value={inputs["email"]}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <Form.Label htmlFor='role' className="form-label font-weight-bold text-muted text-uppercase">Ruolo</Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                className="form-control" 
                                                name='role'
                                                value={getCurrentRole()}
                                                disabled
                                            >
                                                {getAvailableRoleOptions().map((option, index) => (
                                                    <option key={index} value={option.value}>{option.label}</option>
                                                ))}
                                            </Form.Control>
                                        </div>
                                        
                                        {/* Conditional Agency Field - Single or Multiple Select */}
                                        <div className="col-md-12 mb-3" key="4">
                                            <Form.Group>
                                                <Form.Label htmlFor='agency' className="form-label font-weight-bold text-muted text-uppercase">
                                                    {AgentString.agency}
                                                </Form.Label>
                                                
                                                <Form.Control 
                                                    type="text" 
                                                    className="mb-3" 
                                                    name='agency' 
                                                    value={inputs['agency'] || ''} 
                                                    disabled
                                                />
                                            </Form.Group>
                                        </div>

                                        {/* Managed Agencies Display */}
                                        {inputs.managed_agencies && inputs.managed_agencies.length > 0 && (
                                            <div className="col-md-12 mb-3">
                                                <Form.Label className="form-label font-weight-bold text-muted text-uppercase">
                                                    Agenzie Gestite
                                                </Form.Label>
                                                <div className="d-flex flex-wrap">
                                                    {inputs.managed_agencies.map((agency, index) => (
                                                        <Badge key={index} variant="info" className="mr-2 mb-2 p-2" style={{fontSize: '0.9em'}}>
                                                            {agency.name || agency}
                                                        </Badge>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                        
                                        {/* Commission and Permissions Fields */}
                                        <div className="col-md-12 mb-3">
                                            <hr />
                                            <h5 className="mb-3 font-weight-bold">Commissioni e Permessi</h5>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label htmlFor='can_force_edit' className="form-label font-weight-bold text-muted text-uppercase">Può Forzare Modifica</Form.Label>
                                            <div>
                                                <Form.Check 
                                                    type="switch" 
                                                    name="can_force_edit" 
                                                    id="can_force_edit" 
                                                    checked={!!inputs.can_force_edit} 
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label htmlFor='min_commission' className="form-label font-weight-bold text-muted text-uppercase">Commissione Minima</Form.Label>
                                            <Form.Control 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                name="min_commission" 
                                                value={inputs.min_commission || 0} 
                                                disabled
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label htmlFor='max_commission' className="form-label font-weight-bold text-muted text-uppercase">Commissione Massima</Form.Label>
                                            <Form.Control 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                name="max_commission" 
                                                value={inputs.max_commission || 0} 
                                                disabled
                                            />
                                        </div>

                                    </div>
                                    
                                    <Button type="button" className='mx-2' onClick={()=>{setShowPasswordModal(true)}}>{PublicStrings.changePassword}</Button>

                                </Form>
                                )}
                            </Card.Body>
                        </Card>

                        
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default Profile;
